var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-wrapper"},[_c('x-filter-group',{attrs:{"data":_vm.filters,"activeFilters":_vm.activeFilters,"selectedItems":_vm.selectedItems,"options":_vm.filterOptions,"settings":"","maxHeight":"80vh","maxWidth":"400"},on:{"expand":_vm.onExpand,"order":_vm.onOrder,"remove":_vm.onRemove,"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }